// extracted by mini-css-extract-plugin
export default {"collapsible-elm":"CollapsibleElm_collapsible-elm__E6LWB","elm-closed":"CollapsibleElm_elm-closed__Tf7CD","show-bottom-gradient":"CollapsibleElm_show-bottom-gradient__7lC3n"};